// Port de app/intro.tsx.
import { Carregando } from "@/app/Carregando";
import EntradaDesktop from "@/components/desktop/EntradaDesktop";
import { lazy } from "react";

const IntroScreen = lazy(() => import("@/screens/Intro"));

export default function IntroRoute() {
  return (
    // WEB: no desktop (≥1024px) a tela vai num card ao lado do painel da marca; no
    // celular o EntradaDesktop não embrulha nada.
    <EntradaDesktop>
      <Carregando cor="#294956">
        <IntroScreen />
      </Carregando>
    </EntradaDesktop>
  );
}
